import { ProductServices } from '@/services/product.service'

const state = {
  loading: false,
  dialog: false,
  overlay: true,
  brands: [],
  category: [],
  supplier: [],
  suppliercari: [],
  suppliergold: [],
  totalprodukmapping: 0,
  sellerproduct: {
    productlist: [],
    cities: {
      cityname: ''
    },
    province: {
      provincename: ''
    },
    contact: ''
  },
  besthit: [],
  productpricing: [],
  productpricingcari: [],
  product: []
}
const actions = {
  setloading ({ commit }, data) {
    commit('setloading', data)
  },
  clearsellerproduct ({ commit }) {
    commit('clearsellerproduct')
  },
  setdialog ({ commit }, diag) {
    commit('setdialog', diag)
  },
  getBrands ({ commit }) {
    commit('setloading', true)
    ProductServices.getBrands().then(value => {
      commit('setloading', false)
      commit('setbrand', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getCategory ({ commit }) {
    commit('setloading', true)
    ProductServices.getProductCategory().then(value => {
      commit('setloading', false)
      commit('setcategory', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getSupplier ({ commit }) {
    commit('setloading', true)
    ProductServices.getSupplier().then(value => {
      commit('setloading', false)
      commit('setsupplier', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getSupplierCari ({ commit }, cari) {
    commit('setloading', true)
    ProductServices.cariSeller(cari).then(value => {
      commit('setloading', false)
      commit('setsuppliercari', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getSupplierGold ({ commit }) {
    commit('setloading', true)
    ProductServices.getSupplierGold().then(value => {
      commit('setloading', false)
      commit('setsuppliergold', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getSellerProducts ({ commit }, id) {
    commit('setloading', true)
    commit('clearsellerproduct')
    ProductServices.getSellerProducts(id).then(value => {
      commit('setloading', false)
      commit('setsellerproduct', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getBestHit ({ commit }) {
    commit('setloading', true)
    ProductServices.getBestHit().then(value => {
      commit('setloading', false)
      commit('setbesthit', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getProducPricingByBrandId ({ commit }, brandid) {
    commit('setloading', true)
    ProductServices.getProcuctPricingByBrand(brandid).then(value => {
      commit('setloading', false)
      commit('setproductpricing', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getProducPricingByProductId ({ commit }, productid) {
    commit('setloading', true)
    ProductServices.getProcuctPricingByProductId(productid).then(value => {
      commit('setloading', false)
      commit('setproductpricing', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getProducByBrandId ({ commit }, brandid) {
    commit('setloading', true)
    ProductServices.getProcuctByBrandId(brandid).then(value => {
      commit('setloading', false)
      commit('setproduct', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getProducPricingcari ({ commit }, cari) {
    commit('setloading', true)
    ProductServices.getProcuctPricingCari(cari).then(value => {
      commit('setloading', false)
      commit('setproductpricingcari', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  }
}
const mutations = {
  setloading (state, s) {
    state.loading = s
    state.overlay = s
  },
  setdialog (state, s) {
    state.dialog = s
  },
  setbrand (state, s) {
    state.brands = []
    state.brands = s.data
    state.loading = false
    state.overlay = false
  },
  setcategory (state, s) {
    state.category = []
    state.category = s.data
    state.loading = false
    state.overlay = false
  },
  setsupplier (state, s) {
    state.supplier = []
    state.supplier = s.data
    state.loading = false
    state.overlay = false
  },
  setsuppliercari (state, s) {
    state.suppliercari = []
    state.suppliercari = s.data.content
    state.loading = false
    state.overlay = false
  },
  setsuppliergold (state, s) {
    state.suppliergold = []
    state.suppliergold = s.data.content
    state.loading = false
    state.overlay = false
  },
  clearsellerproduct (state) {
    state.sellerproduct.avatar = ''
    state.sellerproduct.cities.cityname = ''
    state.sellerproduct.province.provincename = ''
    state.sellerproduct.contact = ''
  },
  setsellerproduct (state, s) {
    state.sellerproduct = {}
    state.sellerproduct = s.data
    state.loading = false
    state.overlay = false
  },
  setbesthit (state, s) {
    state.besthit = []
    state.besthit = s.data
    state.loading = false
    state.overlay = false
  },
  setproductpricing (state, s) {
    state.productpricing = []
    state.productpricing = s.data.content
    state.loading = false
    state.overlay = false
  },
  setproductpricingcari (state, s) {
    state.productpricingcari = []
    state.productpricingcari = s.data.content
    state.loading = false
    state.overlay = false
  },
  setproduct (state, s) {
    state.product = []
    state.product = s.data
  }
}

export const ProductStore = {
  namespaced: true,
  state,
  actions,
  mutations
}
